import { Icon, Text, SearchInput, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';
import { Pressable } from 'react-native';

import { HeaderSection } from './components/HeaderSection';
import { RestrictedCustomersList } from './components/RestrictedCustomersList';
import { SubHeader } from './components/SubHeader';
import { searchPlaceholder } from './constants';
import { BlockListTypes } from './types';

export const ContainerDesktop: React.FC<BlockListTypes.Props> = ({
  currentOptoutId,
  sendRetryUnlockCustomer,
  isMobile,
  onSetSearchTerm,
  onClearSearchTerm,
  onLoadMore,
  blockList,
  blockListLoading,
  blockListRetryLoading,
  filtered,
  onRefresh,
  toggleOpen,
  isOpenWarning,
}) => {
  return (
    <VStack
      px={Utils.Responsive.TabletDesktop({
        tablet: Spacing['inline.xxxs'],
        desktop: Spacing['inline.xs'],
      })}
      py={Spacing['inline.xxxs']}
      alignSelf="center"
      flex={1}>
      <VStack flex={1} justifyContent="flex-start">
        <HeaderSection isMobile={isMobile} />
        <SubHeader onRefresh={onRefresh} isMobile={isMobile} />
        <VStack
          flex={1}
          bg={{ base: 'transparent', sm: Color['neutral.white'] }}
          px={{ sm: Spacing['inline.xxs'] }}
          pt={Spacing['stack.xxs']}>
          <>
            <Box paddingBottom={Spacing['inline.nano']}>
              <SearchInput
                isLoading={blockListLoading}
                onClear={onClearSearchTerm}
                onSearch={onSetSearchTerm}
                placeholder={searchPlaceholder}
              />
            </Box>

            {isOpenWarning && (
              <HStack
                testID="warning-container"
                backgroundColor="rgba(254, 225, 178, 0.4)"
                borderRadius="8px"
                mt={Spacing['inline.nano']}
                mb={Spacing['inline.xxxs']}
                paddingX={Spacing['inline.xxxs']}
                paddingY={Spacing['inline.nano']}
                space="6px"
                alignItems="center"
                justifyContent="space-between">
                <HStack paddingRight={Spacing['inline.quarck']} flex={1} alignItems="center">
                  <Icon
                    testId="warning-icon"
                    name="Warning"
                    size="xs"
                    color={Color['feedback.attention.default']}
                  />
                  <Text
                    paddingLeft={Spacing['inline.xxxs']}
                    color="neutral.black"
                    fontSize={Typography['fontsize.md']}
                    variant="regular">
                    <Text fontWeight={Typography['fontweight.semibold']}>Atenção:</Text> É
                    necessário que você pesquise pelos clientes para visualizar os bloqueados. Após
                    solicitar o desbloqueio, você não poderá reenviar a solicitação no período de 3
                    horas.
                  </Text>
                </HStack>

                <Pressable onPress={toggleOpen}>
                  <Icon
                    testId="warning-icon"
                    name="Close"
                    size="xxxs"
                    color={Color['neutral.dark']}
                  />
                </Pressable>
              </HStack>
            )}

            <RestrictedCustomersList
              blockListRetryLoading={blockListRetryLoading}
              sendRetryUnlockCustomer={sendRetryUnlockCustomer}
              blockList={blockList}
              blockListLoading={blockListLoading}
              onLoadMore={onLoadMore}
              filtered={filtered}
              currentOptoutId={currentOptoutId}
            />
          </>
        </VStack>
      </VStack>
    </VStack>
  );
};
